export default (regex, string) => {return regex.test(string);
};
